import m from "../../geodata/es2015/senegalHigh";
window.am4geodata_senegalHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/senegalHigh.js
// module id = null
// module chunks = 